export default "__VITE_ASSET__Ctpde0bM__"